/** Универсальная модальная оболочка: на desktop по центру, на мобильном — снизу экрана. */
import { useEffect, type ReactNode } from "react";
import { createPortal } from "react-dom";

interface Props {
	ariaLabel: string;
	children: ReactNode;
	className?: string;
	containerClassName?: string;
	onClose?: () => void;
}

export const Modal = ({
	ariaLabel,
	children,
	className = "",
	containerClassName = "",
	onClose,
}: Props) => {
	useEffect(() => {
		if (!onClose) return;
		const onKeyDown = (event: KeyboardEvent) => {
			if (event.key === "Escape") onClose();
		};
		window.addEventListener("keydown", onKeyDown);
		return () => window.removeEventListener("keydown", onKeyDown);
	}, [onClose]);

	return createPortal(
		<div
			className={`fixed inset-0 z-100 flex items-end bg-modal-backdrop md:grid md:place-items-center md:p-5 ${containerClassName}`}
			role="presentation"
			onClick={(event) => {
				if (event.target === event.currentTarget) onClose?.();
			}}
		>
			<section
				className={`max-h-modal w-full overflow-y-auto rounded-t-lg border border-border bg-surface shadow-xl md:max-h-modal-desktop md:rounded-lg md:shadow-lg ${className}`}
				role="dialog"
				aria-modal="true"
				aria-label={ariaLabel}
			>
				{children}
			</section>
		</div>,
		document.body,
	);
};
